import { reactive, shallowReactive } from "vue";
/**
 * Which of the navigation search dialogs are open, shared by the trigger and the dialogs.
 */
export const navSearchState = reactive({
    paletteOpen: false,
    shortcutsOpen: false,
});
const actions = shallowReactive(new Map());
let nextId = 0;
export function nextNavSearchActionId() {
    return 'action:' + (nextId++);
}
/**
 * Offers the action in the navigation search, until the returned function is called.
 */
export function registerNavSearchAction(action) {
    actions.set(action.id, action);
    return () => {
        actions.delete(action.id);
    };
}
/**
 * The registered actions that can be triggered right now: their element is on screen and they are
 * not disabled. An element inside a collapsed dropdown counts as not visible.
 */
export function visibleNavSearchActions() {
    return [...actions.values()]
        .filter(action => action.element.isConnected
        && action.element.offsetParent !== null
        && !action.disabled());
}
/**
 * The label of the modifier key of the shortcuts: ⌘ on a Mac, Ctrl everywhere else.
 */
export function shortcutModifierLabel() {
    const platform = navigator.userAgentData?.platform ?? navigator.platform ?? navigator.userAgent;
    return /mac|iphone|ipad/i.test(platform) ? '⌘' : 'Ctrl';
}
